




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class AccountPersonAvatar extends Vue {
  image = false

  @Prop()
  readonly name!: string | null | undefined

  @Prop()
  readonly avatarUrl!: string

  @Prop({ type: String, default: 'xs' })
  readonly size!: string

  @Prop({ default: false })
  readonly loading!: boolean

  get initials () {
    if (this.name) {
      const parts = this.name.split(/\s+/, 2)
      if (parts.length === 1) {
        return parts[0].substr(0,2).toLowerCase().replace(/^.?/, a => a.toUpperCase())
      } else {
        return (parts[0].substr(0,1) + parts[1].substr(0,1)).toUpperCase()
      }
    } else {
      return null
    }
  }

  @Watch('avatarUrl')
  load () {
    this.$emit('avatar-url-load', this.image = false)
  }
}
